var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ChartBullsEye } from '../svg-elements/module';
import { HtmlLegendDots } from "../html-elements/module";
import { GraphControllerV2 } from './graph-v2';
import { slugify } from '../d3-services/_helpers';
var pgvLabels = ["> 40 mm/s", "20-40 mm/s", "16-20 mm/s", "8.5-16 mm/s", "5-8.5 mm/s", "2-5 mm/s"];
var ConcentricMms = /** @class */ (function (_super) {
    __extends(ConcentricMms, _super);
    function ConcentricMms(main, data, element, mapping, segment) {
        var _this = _super.call(this, main, data, element, mapping, segment) || this;
        _this.main = main;
        _this.data = data;
        _this.element = element;
        _this.mapping = mapping;
        _this.segment = segment;
        _this.yearGroups = [];
        _this.pre();
        return _this;
    }
    ConcentricMms.prototype.pre = function () {
        this._addScale('x', 'linear', 'horizontal', 'group');
        this._addScale('r', 'band', 'radius', 'group');
        this._addMargin(0, 60, 90, 0);
        this._addPadding(0, 0, 0, 0);
    };
    ConcentricMms.prototype.init = function () {
        var self = this;
        this.config.paddingInner = 0;
        this.config.paddingOuter = .1;
        this.config.extra.minRadius = 20;
        this.config.extra.radiusFactor = (window.innerWidth < 700) ? 2.4 : 3.6;
        _super.prototype._init.call(this);
        var svgId = "svg-wrapper-" + this.mapping.slug;
        var container = document.createElement('section');
        container.style.height = (this.mapping.args[0] === "def") ? "30px" : "200px";
        container.style.width = "100%";
        container.id = svgId;
        this.element.appendChild(container);
        _super.prototype._svg.call(this, container);
        this.chartConcentrics = new ChartBullsEye(this, pgvLabels);
        if (this.mapping.args[0] === "def") {
            this.legend = new HtmlLegendDots(this);
        }
        else {
            this.update(this.data, this.segment, false);
        }
    };
    ConcentricMms.prototype.prepareData = function (data) {
        /*
        [ (years)
            [ (pgvs)
                {
                    label : (prop key)
                    colour:
                    value: (prop value)
                }
            ]
        ]
        */
        var _this = this;
        var grouped = [];
        var props = this.mapping.parameters[0].map(function (m) { return !Array.isArray(m.column) ? m.column : ""; });
        if (this.mapping.args[0] == "years") {
            var yearData = data.filter(function (w) { return w._year === parseInt(_this.mapping.args[1]); });
            var _loop_1 = function (i) {
                var group = [];
                var _loop_2 = function (p) {
                    var prop = !Array.isArray(p.column) ? p.column : "";
                    var part = {
                        label: prop,
                        pgv: pgvLabels[i],
                        pgvIndex: i,
                        colour: p.colour,
                        value: yearData.map(function (m) { return m[(6 - i) + '-' + prop]; }).reduce(function (total, item) { return total + item; })
                    };
                    group.push(part);
                };
                for (var _i = 0, _a = this_1.mapping.parameters[0]; _i < _a.length; _i++) {
                    var p = _a[_i];
                    _loop_2(p);
                }
                // stack voor pgv
                grouped.push(group);
            };
            var this_1 = this;
            // group by pgv ... 
            for (var i = 0; i < 6; i++) {
                _loop_1(i);
            }
        }
        //   this.labels = grouped.map( g => g.label);
        //  keys for stacking dit zijn de procedurestappen 
        // this.keys = Object.keys(grouped[0]).filter( k => k != 'label');
        // this.normalizedStack = d3.stack()
        //     .offset(d3.stackOffsetExpand)
        //     .keys(this.keys);
        return {
            "history": null,
            "latest": null,
            "slice": null,
            "grouped": grouped,
            "stacked": null //this.normalizedStack(grouped)
        };
    };
    ConcentricMms.prototype.draw = function (data) {
        this.scales.x.set([0, 1]);
        // we need one system for yscale ..
        this.scales.r.set(pgvLabels.map(function (l) { return slugify(l); }));
        // width data we can draw items
        // this.chartBullsEye.draw(data);
        this.chartConcentrics.draw(data.grouped);
    };
    ConcentricMms.prototype.redraw = function (data) {
        _super.prototype.redraw.call(this, data.grouped);
        this.chartConcentrics.redraw();
    };
    ConcentricMms.prototype.update = function (data, segment, update) {
        _super.prototype._update.call(this, data, segment, update);
    };
    return ConcentricMms;
}(GraphControllerV2));
export default ConcentricMms;
